import { Action } from '@ngrx/store';
import { Negotiation } from '@vestiaire/api-sdk-angular';
import { MmaoData } from '@app/analytics/models/types';

export const ADD_MMAO = '[mmao] add mmao';
export const REMOVE_MMAO = '[mmao] remove mmao';

export const MMAO_CTA_CLICK = '[mmao] open negotiation popin';
export const MMAO_ACCEPT = '[mmao] Seller accept negotiation';
export const MMAO_REJECT = '[mmao] Seller reject negotiation';
export const MMAO_SUBMIT = '[mmao] Buyer make an offer';
export const MMAO_CHAT_ANSWER = '[mmao] Chat answer';
export const MMAO_MAKE_OFFER_SUCCESS = '[mmao] negotiation created';

export class AddMmao implements Action {
  constructor(public payload: { negotiation: Negotiation; commentId: string }) {}
  readonly type = ADD_MMAO;
}

export class RemoveMmao implements Action {
  constructor(public payload: Negotiation) {}
  readonly type = REMOVE_MMAO;
}

export class MmaoCtaClick implements Action {
  readonly type = MMAO_CTA_CLICK;
  constructor(public payload: MmaoData) {}
}

export class MmaoAccept implements Action {
  readonly type = MMAO_ACCEPT;
  constructor(public payload: MmaoData) {}
}

export class MmaoReject implements Action {
  readonly type = MMAO_REJECT;
  constructor(public payload: MmaoData) {}
}

export class MmaoSubmit implements Action {
  readonly type = MMAO_SUBMIT;
  constructor(public payload: MmaoData) {}
}

export class MmaoChatAnswer implements Action {
  readonly type = MMAO_CHAT_ANSWER;
  constructor(public payload: MmaoData) {}
}

export class MmaoMakeOfferSuccess implements Action {
  readonly type = MMAO_MAKE_OFFER_SUCCESS;
  constructor(public payload: MmaoData) {}
}

export type MmaoActions =
  | AddMmao
  | RemoveMmao
  | MmaoCtaClick
  | MmaoAccept
  | MmaoReject
  | MmaoSubmit
  | MmaoChatAnswer
  | MmaoMakeOfferSuccess;
